// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"3b9f5cef","371":"954399e6","465":"3b9f5cef","587":"954399e6","631":"3b9f5cef","874":"954399e6","878":"703a6210"}[chunkId] + ".chunk.css";
};